import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { store, history } from './store';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { palette, typography, overrides } from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';
import { createTheme } from '@material-ui/core';
import * as locales from '@material-ui/core/locale';

validate.validators = {
  ...validate.validators,
  ...validators
};

const LocalizedApp = () => {
  const currentLanguage = useSelector(store => store.settings.currentLanguage);
  const localizedTheme = createTheme({
    palette,
    typography,
    overrides,
    zIndex: {
      appBar: 1200,
      drawer: 1100
    }
  }, locales[currentLanguage?.materialLocale || 'enUs']);

  return (
    <ThemeProvider theme={localizedTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils} locale={'en'}>
        <ConnectedRouter history={history}>
          <Routes />
        </ConnectedRouter>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <LocalizedApp />
    </Provider>
  );
};

export default App;